"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AbstractStruct = void 0;
var fast_deep_equal_1 = __importDefault(require("fast-deep-equal"));
var class_transformer_1 = require("class-transformer");
var handle_validation_errors_1 = require("../utils/handle-validation-errors");
var class_validator_1 = require("class-validator");
var AbstractStruct = (function () {
    function AbstractStruct() {
    }
    AbstractStruct.parseJsonObject = function (json, options) {
        if (options === void 0) { options = {}; }
        var model = new this();
        Object.assign(model, (0, class_transformer_1.plainToInstance)(this, json, __assign({ excludeExtraneousValues: true }, options)));
        return model;
    };
    AbstractStruct.withDefaultValues = function () {
        var model = new this();
        Object.assign(model, (0, class_transformer_1.plainToInstance)(this, {}));
        return model;
    };
    AbstractStruct.from = function (obj) {
        return (0, class_transformer_1.plainToInstance)(this, (0, class_transformer_1.instanceToPlain)(obj), {
            exposeUnsetFields: false,
            excludeDefaultValues: true,
        });
    };
    AbstractStruct.prototype.clone = function (overrides) {
        if (overrides === void 0) { overrides = {}; }
        return (0, class_transformer_1.plainToInstance)(this.constructor, __assign(__assign({}, this.serialize({ ignoreDecorators: true })), overrides), {
            exposeUnsetFields: false,
            excludeDefaultValues: true,
        });
    };
    AbstractStruct.prototype.toMutable = function () {
        return this.clone();
    };
    AbstractStruct.prototype.validate = function (options) {
        var args = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            args[_i - 1] = arguments[_i];
        }
        (0, handle_validation_errors_1.handleValidationErrors)((0, class_validator_1.validateSync)(this, options), this, options === null || options === void 0 ? void 0 : options.ignoreErrors);
        return this;
    };
    AbstractStruct.prototype.equals = function (obj, options) {
        var _a;
        var self = structuredClone(this);
        var compareObj = structuredClone(obj);
        (_a = options === null || options === void 0 ? void 0 : options.omittingKeys) === null || _a === void 0 ? void 0 : _a.forEach(function (k) {
            delete self[k];
            delete compareObj[k];
        });
        try {
            return (0, fast_deep_equal_1.default)((0, class_transformer_1.instanceToPlain)(self), (0, class_transformer_1.instanceToPlain)(compareObj));
        }
        catch (_b) {
            return false;
        }
    };
    AbstractStruct.prototype.serialize = function (options) {
        var _a;
        if (options === void 0) { options = {}; }
        (_a = options.exposeUnsetFields) !== null && _a !== void 0 ? _a : (options.exposeUnsetFields = false);
        options.enableCircularCheck = true;
        return (0, class_transformer_1.instanceToPlain)(this, options);
    };
    return AbstractStruct;
}());
exports.AbstractStruct = AbstractStruct;
//# sourceMappingURL=abstract-struct.js.map